import React from "react";

const CreateEmployeeAttendance = React.lazy(() =>
	import("./CreateEmployeeAttendance")
);

export const employeeAttendanceRoutes = [
	{
		path: "/admin/employeeAttendances/create",
		name: "Create Employee Attendance",
		element: <CreateEmployeeAttendance />,
	},
];
